import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Typography from '../../common/Typography';
import Collapse from '../../common//Collapse';
import ArrowIcon from '../../icons/Arrow';
import Search from '../../icons/Search';

const TitleTag = styled(Typography)`
  margin: 0px;
  color: rgb(90, 113, 149);
  margin: 15px 0px;
`;

const ListContent = styled.div`
  margin-top: 56px;
`;

const List = styled(Typography)`
  margin: 2px 0px;
  a {
    padding: 8px 0px;
    color: ${({ theme }) => theme.colors.TextAlpha};
    &:hover {
      color: ${({ theme }) => theme.colors.Primary};
    }
  }
  @media screen and (max-width: 768px) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.Neutral[200]};
    margin: 0px;
    a {
      padding: 15px;
    }
  }
`;

const Back = styled(ArrowIcon)`
  padding: 20px 15px;
  flex: 0 0 45px;
`;

const ListHeader = styled.div`
  background: ${({ theme }) => theme.colors.Primary};
  height: 56px;
  top: 0px
`;

const Title = styled(Typography)`
  max-width: 250px;
  color: #fff;
`;

const SearchIcon = styled(Search)`
  fill: #fff;
  width: 20px;
  right: 8px;
  top: 20px;
`;

const ListComponent = ({ categories, activeIndex, isMobile }) => (
  <>
    {categories.map((each, index) =>
      each.subtype ? (
        <div key={index} className={`${index === activeIndex ? 'dB' : 'dN'}`}>
          <Collapse data={each.subdata} isMobile={isMobile} />
        </div>
      ) : (
        <div key={index} className={`${index === activeIndex ? 'dB' : 'dN'}`}>
          <TitleTag tagName="h3" modifiers={['bt1']}>
            Select Sub Category
          </TitleTag>
          <ul>
            {categories[index].subcat.map((each, index) => (
              <List tagName="li" modifiers={['bt1']} key={`subcatList${index}`}>
                <a className="dB" href={each.href}>
                  {each.name}
                </a>
              </List>
            ))}
          </ul>
        </div>
      )
    )}
  </>
);

const SubCategoryList = props => {
  const { categories, activeIndex, isMobile, handleBack, setOpenSearch } = props;

  if (isMobile) {
    return (
      <>
        <ListHeader className="dFA w100 pF zi1">
          <Back onClick={() => handleBack(false)} />
          <Title className="f1" tagName="h1" modifiers={['medium', 'h3']}>
            Select a Subcategory
          </Title>
          <SearchIcon className="pA" onClick={() => setOpenSearch(true)} />
        </ListHeader>
        <ListContent>
          {categories && categories[activeIndex] && categories[activeIndex].subtype ? (
            <Collapse data={categories[activeIndex].subdata} isMobile={isMobile} />
          ) : (
            <ul>
              {categories[activeIndex].subcat.map((each, index) => (
                <List tagName="li" modifiers={['bt1', 'medium']} key={`subcatList${index}`}>
                  <a className="dB" href={each.href}>
                    {each.name}
                  </a>
                </List>
              ))}
            </ul>
          )}
        </ListContent>
      </>
    );
  }
  return <ListComponent categories={categories} activeIndex={activeIndex} isMobile={isMobile} />;
};

SubCategoryList.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      category: PropTypes.object,
      subdata: PropTypes.array,
      subtype: PropTypes.bool,
      subcat: PropTypes.array
    })
  ),
  isMobile: PropTypes.bool,
  activeIndex: PropTypes.number
};

SubCategoryList.defaultProps = {
  categories: {}
};

export default SubCategoryList;
